import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 19,
	viewBox: "0 0 21 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.758 5.48a6.963 6.963 0 1 0 .488 6.327l1.88.785a9 9 0 1 1-.652-8.21l.811-2.83 1.72.494-1.726 6.018-6.018-1.726.493-1.72 3.004.862z",
		fill: "#fff"
	})
});
export default SvgRefresh;
